import { gameSocket, paymentStatusSocket, walletSocket } from '../socket'

/**
 * Closes every socket opened with the current session's token.
 * Called whenever the session ends: user logout or a 403 from the API.
 * Safe to call repeatedly or on a socket that never connected.
 */
export const disconnectSockets = () => {
  const sockets = [walletSocket, paymentStatusSocket, gameSocket]
  sockets.forEach((socket) => {
    try {
      socket?.disconnect()
    } catch (error) {
      console.log('Socket disconnect failed', error)
    }
  })
}
